import React from 'react';


const Root_menu = () => {
  return (
    <nav role="navigation" aria-label="Top Menu">
  <ul>
    <li><a className='active' href="/men">Men</a>
      <ul>
        <li><a href="/men/clothing">Clothing</a></li>
        <li><a href="/men/shoes">Shoes</a></li>
        <li><a href="/men/accessories">Accessories</a></li>
        <li><a href="/men/bags">Bags</a></li>
        <li><a href="/men/watches">Watches</a></li>
        <li><a href="/men/fragrances">Fragrances</a></li>
        <li><a href="/men/grooming">Grooming</a></li>
        <li><a href="/men/sportswear">Sportswear</a></li>
        <li><a href="/men/underwear">Underwear</a></li>
        <li><a href="/men/jewelry">Jewelry</a></li>
      </ul>
    </li>
    <li><a href="/women">Women</a>
      <ul>
        <li><a href="/women/clothing">Clothing</a></li>
        <li><a href="/women/shoes">Shoes</a></li>
        <li><a href="/women/accessories">Accessories</a></li>
        <li><a href="/women/bags">Bags</a></li>
        <li><a href="/women/watches">Watches</a></li>
        <li><a href="/women/fragrances">Fragrances</a></li>
        <li><a href="/women/makeup">Makeup</a></li>
        <li><a href="/women/lingerie">Lingerie</a></li>
        <li><a href="/women/activewear">Activewear</a></li>
        <li><a href="/women/jewelry">Jewelry</a></li>
      </ul>
    </li>

    <li><a href="/deals">Deals</a>
      <ul>
        <li><a href="/deals/flash-sales">Flash Sales</a></li>
        <li><a href="/deals/clearance">Clearance</a></li>
        <li><a href="/deals/daily-deals">Daily Deals</a></li>
      </ul>
    </li>
    <li><a href="/offers">Offers</a>
      <ul>
        <li><a href="/offers/discounts">Discounts</a></li>
        <li><a href="/offers/promotions">Promotions</a></li>
        <li><a href="/offers/coupon-codes">Coupon Codes</a></li>
      </ul>
    </li>
  </ul>
</nav>
    
  );
};

export default Root_menu;